import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { growthShowcase } from '@/mocks/results';

const maxAfter = Math.max(...growthShowcase.map((item) => item.after));

export default function GrowthShowcase() {
  return (
    <section className="relative w-full px-5 md:px-10 pb-20 md:pb-28">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="До и после"
          title="Как растут сообщества на практике"
          description="Реальные примеры роста: с чего начинали клиенты и к чему пришли за несколько месяцев работы с нами."
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {growthShowcase.map((item, index) => (
            <Reveal key={item.company} delay={index * 80} className="h-full">
              <div className="h-full p-6 rounded-lg bg-background-100/70 border border-background-200/70">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-heading text-base md:text-lg text-foreground-950">{item.company}</h3>
                    <p className="mt-1 text-xs text-foreground-500">
                      {item.niche} · {item.period}
                    </p>
                  </div>
                  <span className="flex-none px-3 py-1 rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 text-sm font-bold whitespace-nowrap">
                    {item.growth}
                  </span>
                </div>

                <div className="mt-6 flex items-end justify-between gap-4">
                  <div>
                    <div className="text-xs text-foreground-500">Было</div>
                    <div className="font-heading font-bold text-xl text-foreground-600">
                      {item.before.toLocaleString('ru-RU')}
                    </div>
                  </div>
                  <i className="ri-arrow-right-line text-xl text-primary-400"></i>
                  <div className="text-right">
                    <div className="text-xs text-foreground-500">Стало</div>
                    <div className="font-heading font-bold text-2xl text-primary-500">
                      {item.after.toLocaleString('ru-RU')}
                    </div>
                  </div>
                </div>

                <div className="mt-5 h-2.5 rounded-full bg-background-200/70 overflow-hidden">
                  <div
                    className="h-full rounded-full bg-primary-500"
                    style={{ width: `${Math.round((item.after / maxAfter) * 100)}%` }}
                  ></div>
                </div>

                <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{item.note}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}